import * as React from 'react';
import { cn } from '@/lib/utils';
import { Tooltip as ReactTooltip } from 'react-tooltip';

export function IconVerified(props) {
  const { tooltipPlace = 'top', style, className, ...restProps } = props;

  const id = React.useId();

  return (
    <React.Fragment>
      <svg
        className={cn('size-4 shrink-0 cursor-help text-[#13AFF0]', className)}
        width={14}
        height={14}
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        data-tooltip-id={id}
        data-tooltip-content="Conteúdo gerado pela instituição"
        data-tooltip-place={tooltipPlace}
        style={style}
        {...restProps}
      >
        <path
          d="M7 0l1.982 2.214 2.968-.164-.164 2.968L14 7l-2.214 1.982.164 2.968-2.968-.164L7 14l-1.982-2.214-2.968.164.164-2.968L0 7l2.214-1.982L2.05 2.05l2.968.164L7 0z"
          fill="currentColor"
          stroke="#fff"
        />
        <path
          d="M9.238 5.125L6.029 8.792 4.571 7.125"
          stroke="#fff"
          fill="transparent"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>

      <ReactTooltip
        id={id}
        className="tooltip !bg-[#13AFF0] !opacity-100"
      />
    </React.Fragment>
  );
}
